export default "__VITE_ASSET__M6SOFi9I__"